enum Paths {
    user = '/users/users',
    discountsCreate = '/create',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/User/paths.ts